import { render, staticRenderFns } from "./UserTypeEdit.vue?vue&type=template&id=006eb0bb&scoped=true"
import script from "./UserTypeEdit.vue?vue&type=script&lang=js"
export * from "./UserTypeEdit.vue?vue&type=script&lang=js"
import style0 from "./UserTypeEdit.vue?vue&type=style&index=0&id=006eb0bb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "006eb0bb",
  null
  
)

export default component.exports